import { render, staticRenderFns } from "./member-index.vue?vue&type=template&id=371da052&scoped=true"
import script from "./member-index.vue?vue&type=script&lang=js"
export * from "./member-index.vue?vue&type=script&lang=js"
import style0 from "./member-index.vue?vue&type=style&index=0&id=371da052&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371da052",
  null
  
)

export default component.exports